/**
 * twenty-ema-sr-page.js
 *
 * 20 EMA S/R strategy:
 *   Price sitting between EMA(20 on high) and EMA(20 on low) — treated as a
 *   support/resistance band — with RSI(20) picking the direction and the
 *   50 SMA slope confirming the trend.
 *   Long:  price in band + RSI(20) > 50 + 50 SMA sloping up
 *   Short: price in band + RSI(20) < 50 + 50 SMA sloping down
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchTwentyEmaSrData } from '../services/server-api';

const TF_LABELS = { weekly: 'Weekly', daily: 'Daily', fourHour: '4H' };

function renderDetails(entry) {
  const highVal = entry.ema20High != null ? `$${entry.ema20High.toLocaleString(undefined, { maximumFractionDigits: 4 })}` : '—';
  const lowVal  = entry.ema20Low  != null ? `$${entry.ema20Low.toLocaleString(undefined, { maximumFractionDigits: 4 })}`  : '—';
  const rsiVal  = entry.rsi20 != null ? entry.rsi20.toFixed(1) : '—';
  const slopeLabel = entry.sma50Slope === 'up' ? '↑ rising' : '↓ falling';
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">20 EMA High</span>
        <span className="mtf-ind-value zone">{highVal}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">20 EMA Low</span>
        <span className="mtf-ind-value zone">{lowVal}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">RSI(20)</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>{rsiVal}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">SMA50</span>
        <span className="mtf-ind-value zone">{slopeLabel}</span>
      </div>
    </>
  );
}

function TwentyEmaSrPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      '20 EMA S/R',
        icon:       '🧱',
        subtitle:   'Price between EMA(20 high) and EMA(20 low) · RSI(20) + 50 SMA slope confirm direction',
        fetchFn:    fetchTwentyEmaSrData,
        timeframes: ['weekly', 'daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default TwentyEmaSrPage;
